import styled from "@emotion/styled";
import { Container} from "@mui/material";
import React from "react";
import { useState, createContext } from "react";
import bg from "../../../assets/Images/dashboardbg.png";
import NavBar from "../../Components/DashboardComponent/navBar";
import DashboardTabs from "../../Components/DashboardComponent/Tabs";
import DashboardFooter from "../../Components/DashboardComponent/footer";

const ContainerWraper = styled(Container)`
  width: 100%;
  padding: 0 !important;
  position: relative;
  background: ${(props) => props.theme.pageColor};
  min-height: 100vh;
  ::after {
    content: "";
    display: block;
    position: absolute;
    width: 100%;
    height: 320px;
    top: 0%;
    left: 0%;
    background-image: url(${bg});
    background-position: top;
    background-size: cover;
    background-repeat: no-repeat;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
  }
`;
const InnerContainer = styled(Container)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 100vh;
`;


export const WalletContext = createContext(null);
const Dashboard = () => {
  const [connectState, setConnectState] = useState(false);
  return (
    <WalletContext.Provider value={{connectState, setConnectState}}>
      <ContainerWraper maxWidth="xxl">
        <InnerContainer>
          <NavBar />
          <DashboardTabs />
        <DashboardFooter/>
        </InnerContainer>
      </ContainerWraper>
    </WalletContext.Provider>
  );
};

export default Dashboard;
